import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { IcebergDataset } from 'shell-models-lib';
import { FormatTypeCopySink } from './format-type.copysink';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { IcebergFormatWriteSettings } from './format-write-settings/iceberg-format-write-settings';
import { AdvancedStoreWriteSettings } from './store-write-settings/advanced-store-write-settings';

@Metamodel.model({
    name: adfModelTypeMap.iceberg.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(IcebergDataset) }
})
export class IcebergSink extends FormatTypeCopySink {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_FormatReadSettings,
        type: IcebergFormatWriteSettings.MODEL
    })
    public override formatSettings: IcebergFormatWriteSettings;

    @Metamodel.attribute({
        display: stringResources.ModelName_StoreReadSettings,
        type: AdvancedStoreWriteSettings.MODEL,
    })
    public override storeSettings: AdvancedStoreWriteSettings;
}
